import api, { endpoints } from '@/utils/api';

export const getUserNotifications = async (userId, page = 1, pageSize = 20) => {
  try {
    const response = await api.get(`${endpoints.notifications}/${userId}`, {
      params: { page, pageSize }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching notifications:', error);
    throw error;
  }
};

export const markAsRead = async (notificationId) => {
  try {
    const response = await api.patch(`${endpoints.notifications}/${notificationId}/read`);
    return response.data;
  } catch (error) {
    console.error('Error marking notification as read:', error);
    throw error;
  }
};

export const markAllAsRead = async () => {
  try {
    const response = await api.patch(`${endpoints.notifications}/read-all`);
    return response.data;
  } catch (error) {
    console.error('Error marking all notifications as read:', error);
    throw error;
  }
};

export const getUnreadCount = async (userId) => {
  try {
    const response = await api.get(`${endpoints.notifications}/${userId}/unread-count`);
    return response.data;
  } catch (error) {
    console.error('Error fetching unread count:', error);
    throw error;
  }
};

export default {
  getUserNotifications,
  markAsRead,
  markAllAsRead,
  getUnreadCount,
};
